/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import dayjs from 'dayjs';

import type { Registre } from '@/types';

const DATE_FORMAT = 'DD/MM/YYYY';

/**
 * Valide la section « INFORMATIONS DE L'ACTE ».
 *
 * Obligatoires : registre, date de l'acte, numéro.
 * Non obligatoires : heure, ordre, complément.
 *
 * Les clés correspondent aux `name` des champs de l'`InformationsActe`.
 *
 * @param acteData Données de l'étape 1 (acte + enfant).
 * @param selectedRegistre Registre sélectionné dans la modale.
 */
const validationInformationsActe = (
  acteData: Record<string, any>,
  selectedRegistre?: Partial<Registre>,
) => {
  const errors = {
    registre: '',
    sousTypeActe: '',
    dateActe: '',
    numeroActe: '',
  };

  if (_.isEmpty(selectedRegistre)) {
    errors.registre = 'Le registre est obligatoire';
  }

  if (_.isNil(acteData?.sousTypeActe) || acteData.sousTypeActe === '') {
    errors.sousTypeActe = "Le sous type d'acte est obligatoire";
  }

  if (_.isEmpty(acteData?.dateActe)) {
    errors.dateActe = "La date de l'acte est obligatoire";
  } else if (!dayjs(acteData.dateActe, DATE_FORMAT, true).isValid()) {
    errors.dateActe = "La date de l'acte est invalide";
  }

  if (_.isEmpty(_.toString(acteData?.numeroActe))) {
    errors.numeroActe = 'Le numéro est obligatoire';
  }

  return _.pickBy(errors, (value) => value !== '');
};

export default validationInformationsActe;
